export default __webpack_public_path__ + "3492d53c6f7766f9272f1e07323a9591.png";